import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, Box, Grid, MenuItem } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { includes, isEmpty } from "lodash";
import { API_URL } from "../constant";
import axios from "axios";
import moment from "moment";

const validationSchema = yup.object({
    name: yup.string().required("Name is required").matches(/^[A-Za-z\s]*$/, 'Name must contain only letters and spaces'),
    mobile: yup.string().matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number").required("Mobile number is required"),
    gender: yup.number().required("Gender is required"),
    dob: yup.date().required("Date of Birth is required"),
    address: yup.string().required("Address is required"),
    pin_code: yup.string().matches(/^[0-9]{6}$/, "Enter a valid 6-digit PIN Code").required("PIN Code is required"),
    city: yup.string().required("City is required"),
    state: yup.string().required("State is required"),
    relation_type: yup.string().required('Relation type is required'),
    aadhaar_no: yup.string().when('relation_type', {
        is: (val) => val === RELATION_TYPE.COAPPICANT || val === RELATION_TYPE.GUARANTOR,
        then: yup
          .string()
          .matches(/^[0-9]{12}$/, 'Enter a valid 12-digit aadhaar number')
          .required('Aadhaar number is required'),
        otherwise: yup.string().notRequired(),
      }),
});

const RELATION_TYPE = {
	COAPPICANT :'co-applicant',
	REFERENCE : 'reference',
	NOMINEE : 'nominee',
	GUARANTOR : 'guarantor',
}

const RELATIONS = [
  { label: "Husband", value: "husband" },
  { label: "Wife", value: "wife" },
  { label: "Son", value: "son" },
  { label: "Daughter", value: "daughter" },
  { label: "Father", value: "father" },
  { label: "Mother", value: "mother" },
  { label: "Brother", value: "brother" },
  { label: "Sister", value: "sister" },
  { label: "Uncle", value: "uncle" },
  { label: "Aunty", value: "aunty" },
  { label: "Friend", value: "friend" },
  { label: "Nephew", value: "nephew" },
  { label: "Niece", value: "niece" },
  { label: "Father In Law", value: "father-in-law" },
  { label: "Mother In Law", value: "mother-in-law" },
  { label: "Brother In Law", value: "brother-in-law" },
  { label: "Sister In Law", value: "sister-in-law" },
  { label: "Daughter In Law", value: "daughter-in-law" },
  { label: "Neighbour", value: "neighbour" },
  { label: "Office Colleague", value: "colleague" },
  { label: "Land Lord", value: "land-lord" },
  { label: "Self", value: "self" },
  { label: "Grand Father", value: "grand-father" },
  { label: "Grand Mother", value: "grand-mother" },
  { label: "Maternal Grand Father", value: "maternal-grand-father" },
  { label: "Proprietor", value: "proprietor" },
  { label: "Partnership", value: "partnership" },
];

const AddMemberDialog = ({ open, onClose, onSubmit, editData, loanData }) => {
    const initialValues = {
        name: editData?.name || '',
        mobile: editData?.mobile || '',
        gender: editData?.gender || '1',
        dob: editData?.dob || '',
        aadhaar_no: editData?.aadhaar_no || '',
        pan: editData?.pan || '',
        address: editData?.address || '',
        pin_code: editData?.pin_code || '',
        city: editData?.city || '',
        state: editData?.state || '',
        relation_type: editData?.relation_type || RELATION_TYPE.COAPPICANT,
        relation: editData?.relation || '',
      };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema,
    onSubmit: (values) => {
      handleSubmit(values)
    },
  });

  const handlePinChange = async (e) => {
    formik.setFieldValue('pin_code', e.target.value)
    if ((e.target.value).length > 5) {
        const response = await axios.get(`${API_URL}/get_city_by_pin/${e.target.value}`);
        if (!isEmpty(response?.data?.data)) {
            formik.setFieldValue('city', response?.data?.data?.district_name)
            formik.setFieldValue('state', response?.data?.data?.state_name)
        }
    } else {
        formik.setFieldValue('city', '')
        formik.setFieldValue('state', '')
    }
}


const handleSubmit = async(formData) => {
  try{
    const body ={
      ...formData,
      loan_id: loanData?.loan_id,
      customer_id: loanData?.customer_id
    }
    const result = await axios.post(`${API_URL}/customer/loan/${loanData?.loan_id}/loan_members`,body);
    onSubmit();
    formik.resetForm({ values: useFormik.initialValues });
  } catch (error) {
    alert(error);
  }
};

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{display:'flex', justifyContent:'space-between'}}>
        <h3 style={{fontWeight:'bold',}}>Add Member</h3>
        <Button onClick={onClose} color="error" variant="outlined">X</Button>
      </DialogTitle>

      <DialogContent>
          <form onSubmit={formik.handleSubmit}>
            <Box sx={{ p: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Name*" name="name" onChange={formik.handleChange} value={formik.values.name} error={formik.touched.name && Boolean(formik.errors.name)} helperText={formik.touched.name && formik.errors.name} />
                </Grid>
                <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Mobile Number*" name="mobile" inputProps={{maxLength: 10}} onChange={formik.handleChange} value={formik.values.mobile} error={formik.touched.mobile && Boolean(formik.errors.mobile)} helperText={formik.touched.mobile && formik.errors.mobile} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth select label="Gender*" name="gender" onChange={formik.handleChange} value={formik.values.gender} error={formik.touched.gender && Boolean(formik.errors.gender)} helperText={formik.touched.gender && formik.errors.gender}>
                    <MenuItem value={1}>Male</MenuItem>
                    <MenuItem value={2}>Female</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth type="date" label="DOB*" name="dob"  value={formik.values.dob} error={formik.touched.dob && Boolean(formik.errors.dob)} helperText={formik.touched.dob && formik.errors.dob} InputLabelProps={{ shrink: true }} 
                     onChange={(event) => {
                      const formattedDate = moment(event.target.value).format('YYYY-MM-DD');
                      formik.setFieldValue('dob', formattedDate);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth select label="Relation Type*" name="relation_type" onChange={formik.handleChange} value={formik.values.relation_type} error={formik.touched.relation_type && Boolean(formik.errors.relation_type)} helperText={formik.touched.relation_type && formik.errors.relation_type}>
                  {Object.values(RELATION_TYPE).map(relation => (
                        <MenuItem key={relation} value={relation}>
                            {relation.charAt(0).toUpperCase() + relation.slice(1)}
                        </MenuItem>
                        ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth select label="relation*" name="relation" onChange={formik.handleChange} value={formik.values.relation} error={formik.touched.relation && Boolean(formik.errors.relation)} helperText={formik.touched.relation && formik.errors.relation} >
                    {RELATIONS.map(({ label, value }) => (
                        <MenuItem key={value} value={value}>
                            {label}
                        </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Address*" name="address" onChange={formik.handleChange} value={formik.values.address} error={formik.touched.address && Boolean(formik.errors.address)} helperText={formik.touched.address && formik.errors.address} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="PIN Code*" name="pin_code" onChange={handlePinChange} value={formik.values.pin_code} error={formik.touched.pin_code && Boolean(formik.errors.pin_code)} helperText={formik.touched.pin_code && formik.errors.pin_code} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="City*" name="city" onChange={formik.handleChange} value={formik.values.city} error={formik.touched.city && Boolean(formik.errors.city)} helperText={formik.touched.city && formik.errors.city} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="State*" name="state" onChange={formik.handleChange} value={formik.values.state} error={formik.touched.state && Boolean(formik.errors.state)} helperText={formik.touched.state && formik.errors.state} />
                </Grid>
                {includes([RELATION_TYPE.COAPPICANT, RELATION_TYPE.GUARANTOR],formik.values.relation_type) && <><Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Aadhaar no*" name="aadhaar_no" inputProps={{maxLength: 12}} onChange={formik.handleChange} value={formik.values.aadhaar_no} error={formik.touched.aadhaar_no && Boolean(formik.errors.aadhaar_no)} helperText={formik.touched.aadhaar_no && formik.errors.aadhaar_no} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Pan*" name="pan" inputProps={{maxLength: 10}} onChange={formik.handleChange} value={formik.values.pan} error={formik.touched.pan && Boolean(formik.errors.pan)} helperText={formik.touched.pan && formik.errors.pan} />
                </Grid></>}
              </Grid>
            </Box>
            <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                <Button onClick={formik.handleSubmit} variant="contained" color="primary" sx={{width:"30%"}}>Submit</Button>
            </DialogActions>
          </form>
        </DialogContent>
    </Dialog>
  );
};

export default AddMemberDialog;
